//https://www.scala-js.org/doc/interoperability/facade-types.html
//https://www.scala-js.org/doc/interoperability/types.html
//https://stackoverflow.com/questions/43452472/how-do-i-extract-the-right-type-from-my-pseduo-union-type
//https://docs.agora.io/en/Voice/API%20Reference/web/interfaces/agorartc.client.html version 3x
//https://docs.agora.io/en/Voice/API%20Reference/web_ng/index.html version 4x

package com.neurobs.js.agora

import org.scalajs.dom.raw.HTMLElement

import scala.scalajs.js
import scala.scalajs.js.annotation.JSGlobal

//////////////////////////////////////// RTC /////////////////////////////////////////////

@js.native
trait IRemoteTrack extends js.Object {

}

@js.native
trait IRemoteAudioTrack extends js.Object {
	def play(): Unit = js.native
	def stop(): Unit = js.native
	//ranges from 0 (mute) to 1000
	def setVolume(volume: Double): Unit = js.native
}

@js.native
trait IRemoteVideoTrack extends js.Object {
	def play(element: HTMLElement): Unit = js.native
	def stop(): Unit = js.native
}

@js.native
trait IAgoraRTCRemoteUser extends js.Object {
	def audioTrack: js.UndefOr[IRemoteAudioTrack] = js.native
	def hasAudio: Boolean = js.native
	def hasVideo: Boolean = js.native
	def uid: String = js.native
  //def uid: Int | String = js.native
	def videoTrack: js.UndefOr[IRemoteVideoTrack] = js.native
}

@js.native
trait ILocalTrack extends js.Object {

}

@js.native
trait IAgoraRTCClient extends js.Object {
	def channelName: String = js.native
	def connectionState: js.Object = js.native
	def localTracks: js.Array[ILocalTrack] = js.native
	def remoteUsers: js.Array[IAgoraRTCRemoteUser] = js.native
	//def uid: Int | String = js.native
  def uid: String = js.native


	def join(appid: String, channel: String, token: String, UID: String): js.Promise[String] = js.native
	def leave(): js.Promise[Unit] = js.native
  def publish(tracks: ILocalTrack): js.Promise[Unit] = js.native
	def publish(tracks: js.Array[ILocalTrack]): js.Promise[Unit] = js.native
	def unpublish(tracks: ILocalTrack): js.Promise[Unit] = js.native
  def unpublish(tracks: js.Array[ILocalTrack]): js.Promise[Unit] = js.native
	def subscribe(user: IAgoraRTCRemoteUser, mediaType: String): js.Promise[IRemoteTrack] = js.native
	
	//Event = "connection-state-change"
	//def on(event: String, listener: js.Function1[curState: String, revState: String, reason: ConnectionDisconnectedReason = "DEFAULT"]): Unit = js.native
  def on(event: String, listener: js.Function3[String, String, String, Unit]): Unit = js.native

	//Event = "user-published" or "user-unpublished"
	//def on(event: String, listener: js.Function2[user: IAgoraRTCRemoteUser, mediaType: String, Unit]): Unit = js.native
	//Event = "user-left"
	//def on(event: String, listener: js.Function2[user: IAgoraRTCRemoteUser, reason: String, Unit]): Unit = js.native
  def on(event: String, listener: js.Function2[IAgoraRTCRemoteUser, String, Unit]): Unit = js.native

	//Event = "user-joined"
	//def on(event: String, listener: js.Function2[user: IAgoraRTCRemoteUser, Unit]): Unit = js.native
	def on(event: String, listener: js.Function1[IAgoraRTCRemoteUser, Unit]): Unit = js.native

}

@js.native
trait IMicrophoneAudioTrack extends ILocalTrack {

}

@js.native
trait ICameraVideoTrack extends ILocalTrack {
	def play(element: HTMLElement): Unit = js.native
	def stop(): Unit = js.native
}

//https://developer.mozilla.org/en-US/docs/Web/API/MediaDeviceInfo
@js.native
trait MediaDeviceInfo extends js.Object {
	def deviceId: String = js.native //actually DOMString
	def groupId: String = js.native //actually DOMString
	def kind: String = js.native //actually enum, "videoinput" or "audioinput"
	def label: String = js.native //actually DOMString

}

@js.native
@JSGlobal
object AgoraRTC extends js.Object {
	def createClient(clientConfig: js.Object): IAgoraRTCClient = js.native
	def createMicrophoneAudioTrack(): js.Promise[IMicrophoneAudioTrack] = js.native
	def createCameraVideoTrack(): js.Promise[ICameraVideoTrack] = js.native
	def getCameras(skipPermissionCheck: Boolean): js.Promise[js.Array[MediaDeviceInfo]] = js.native
	def getMicrophones(skipPermissionCheck: Boolean): js.Promise[js.Array[MediaDeviceInfo]] = js.native
}



//////////////////////////////////////// RTM /////////////////////////////////////////////

@js.native
trait RtmMessage extends js.Object {
	val text: String = js.native
}

object RtmMessage {
	def apply(text: String): RtmMessage =	js.Dynamic.literal(text = text).asInstanceOf[RtmMessage]
}

@js.native
trait RtmChannel extends js.Object {
	def join() : js.Promise[Unit] = js.native
	def leave() : js.Promise[Unit] = js.native
	def sendMessage(message: js.Object) : js.Promise[Void] = js.native
	//ChannelMessage
  //def on(eventName: String, listener: js.Function1[message: String, memberId: String]) : RtmChannel = js.native
  def on(eventName: String, listener: js.Function2[RtmMessage,String,Unit]) : RtmChannel = js.native
}


@js.native
trait RTMClient extends js.Object {
	//ConnectionStateChanged
	//def on(event: String, listener: js.Function2[newState: String, reason: String, Unit ]): RTMClient
  def on(event: String, listener: js.Function2[String,String,Unit ]): RTMClient
  def login(options: js.Object) : js.Promise[Unit] = js.native
	def logout() : js.Promise[Unit] = js.native
	def createChannel(channel: String) : RtmChannel = js.native

}

@js.native
@JSGlobal
object AgoraRTM extends js.Object {
	def createInstance(appId: String, config: js.Object) : RTMClient = js.native
	def setArea(areaConfig: js.Object) : Unit = js.native
}


